module.exports = __webpack_public_path__ + "media/images/riders/CARINA_CAPPELARI-20d7c0a491889219c47e16d6c5a63311.png";